import { resetWebSockets } from './globals';
import { resetSubscribers } from './manage-subscribers';
export function assertIsWebSocket(webSocketInstance, skip) {
    if (!skip && webSocketInstance instanceof WebSocket === false)
        throw new Error('');
}
;
export function resetGlobalState(url) {
    resetSubscribers(url);
    resetWebSockets(url);
}
;
//# sourceMappingURL=util.js.map